import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  card: {
    marginLeft: "15px",
    borderLeft: `1px solid ${theme.palette.grey[300]}`,
  },
  container: {
    padding: "12px 14px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
  },
  main_content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minWidth: "70px",
  },
  main_label: {
    textAlign: "center",
    fontSize: "9px",
    fontWeight: 600,
    color: "#999",
    textTransform: "uppercase",
    letterSpacing: "0.2px",
    marginBottom: "3px",
  },
  main_value: {
    fontSize: "22px",
    fontWeight: 700,
    color: "#222",
    lineHeight: 1,
  },
  breakdown: {
    display: "flex",
    gap: "12px",
    flex: 1,
  },
  breakdown_item: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minWidth: "65px",
    padding: "7px 10px",
    borderRadius: "6px",
    backgroundColor: "#fafafa",
    border: "1px solid #f0f0f0",
    transition: "all 0.2s ease",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#f5f5f5",
      borderColor: "#e8e8e8",
    },
  },
  breakdown_label_with_icon: {
    display: "flex",
    alignItems: "center",
    gap: "3px",
    justifyContent: "center",
  },
  breakdown_label: {
    fontSize: "9px",
    fontWeight: 600,
    color: "#999",
    textTransform: "uppercase",
    letterSpacing: "0.2px",
    marginBottom: "2px",
  },
  breakdown_value: {
    fontSize: "16px",
    fontWeight: 700,
    color: "#333",
    lineHeight: 1,
  },
  small_lock_icon: {
    fontSize: "10px",
    color: "#f9a825",
  },
  small_check_icon: {
    fontSize: "10px",
    color: "#4caf50",
  },
}));

export default useStyles;
